import React from 'react';
import {assertNever} from '@practicegenius/pg-util/src/TypescriptUtils';
import {
  makeChannelUpdateMessage,
  AppToSitesMessage,
} from '@practicegenius/domain/src/sites-mobile-app/messages';
import {inMobileApp, postMessageToMobileApp} from '../utils/MobileApp';

/** Ask mobile app for debug info */
export const useAppDebugInfo = () => {
  const [debugInfo, setDebugInfo] = React.useState<null | {
    isDebug: boolean;
  }>(null);

  React.useEffect(() => {
    if (!inMobileApp) return;

    postMessageToMobileApp(makeChannelUpdateMessage('debug', true));
    postMessageToMobileApp({
      type: 'request_app_debug_info',
    });

    const handleMobileAppEvent = async (event: MessageEvent) => {
      if (typeof event.data !== 'string') return;

      try {
        // TODO We need a more reliable way to parse events from the mobile app such that new additions to sites-dot don't cause this logic to choke
        const data = JSON.parse(event.data) as AppToSitesMessage;

        if (data.channel !== 'debug') return;

        switch (data.type) {
          case 'receive_app_debug_info':
            return setDebugInfo(data.payload);

          default:
            assertNever(data);
        }
      } catch (e) {
        // This might handle messages from other sources and they might not be JSON, so we need to ignore them
        if (e instanceof SyntaxError) {
          // JSON failed to parse, so it must not be a known message
          return;
        }

        // otherwise, the error is unexpected and should be thrown
        throw e;
      }
    };

    window.addEventListener('message', handleMobileAppEvent, true);
    return () => {
      window.removeEventListener('message', handleMobileAppEvent, true);
      postMessageToMobileApp(makeChannelUpdateMessage('debug', false));
    };
  }, []);

  return debugInfo;
};
